import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function useDesktop(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('lg'));
}
